module.exports = __webpack_public_path__ + "static/media/save.cca22e04.svg";